import type { TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  'auth.general': {
    verifyCodeTitle: {
      en: 'Enter {{count}}-digit code',
      fr: 'Saisissez le code à {{count}} chiffres',
    },
    weSentEmail: {
      en: 'We just sent you an email to {{ email }}',
      fr: 'Nous venons de vous envoyer un e-mail à {{ email }}',
    },
    didntReceiveEmail: {
      en: `You didn't receive an email?`,
      fr: `Vous n'avez pas reçu d'e-mail ?`,
    },
  },
  'auth.-google-oauth-sign': {
    signUp: {
      en: 'Sign up with Google',
      fr: 'S’inscrire avec Google',
    },
    logIn: {
      en: 'Sign in with Google',
      fr: 'Se connecter avec Google',
    },
  },
  'auth.-authbody': {
    english: {
      en: 'English',
      fr: 'Anglais',
    },
    french: {
      en: 'French',
      fr: 'Français',
    },
    sideTitle: {
      en: 'Write your first SEO optimised content.',
      fr: 'Écrivez votre premier contenu optimisé pour le SEO.',
    },
    signIn: {
      en: 'Sign in',
      fr: 'Se connecter',
    },
    signUp: {
      en: 'Sign up',
      fr: `S'inscrire`,
    },
    register: {
      en: 'Register',
      fr: "S'inscrire",
    },
    dontHaveAccount: {
      en: "Don't have an account?",
      fr: "Vous n'avez pas de compte?",
    },
    alreadyHaveAccount: {
      en: 'Already have an account?',
      fr: 'Vous avez déjà un compte?',
    },
    quoteText: {
      en: 'Blym helped me escalate 10 ranks in my google results, I am amazed with the results!',
      fr: 'Blym m’a aidé à grimper de 10 places dans mes résultats Google, je suis émerveillé par les résultats !',
    },
    quoteAuthor: {
      en: 'Danish',
      fr: 'Danish',
    },
    quoteAuthorRole: {
      en: 'President of Indonesia',
      fr: 'Président de l’Indonésie',
    },
    requestDemo: {
      en: 'Request demo',
      fr: 'Demander une démo',
    },
  },
  'auth.-terms-and-privacy-policy': {
    signingUpNote: {
      en: `By signing in, you acknowledge that you have read and understood, and agree to Blym's <0>Terms</0> and <1>Privacy Policy</1>.`,
      fr: `En vous connectant, vous reconnaissez avoir lu, compris et accepté les <0>Conditions d'utilisation</0> et la <1>Politique de confidentialité</1> de Blym.`,
    },
  },
  'auth.signin': {
    login: {
      en: 'Login',
      fr: 'Connexion',
    },
    forgotPassword: {
      en: 'Forgot password',
      fr: 'Mot de passe oublié',
    },
    resetPassword: {
      en: 'Reset password',
      fr: 'Réinitialiser le mot de passe',
    },
    loginToYourAccount: {
      en: 'Login to your account',
      fr: 'Connectez-vous à votre compte',
    },
    signInToBlym: {
      en: 'Sign in to Blym',
      fr: 'Se connecter à Blym',
    },
    welcomeBack: {
      en: 'Welcome back!',
      fr: 'Bienvenue à nouveau !',
    },
    signIn: {
      en: 'Sign in',
      fr: 'Se connecter',
    },
    terms: {
      en: 'Terms',
      fr: 'Mots-clés',
    },
    privacyPolicy: {
      en: 'Privacy Policy',
      fr: 'Politique de confidentialité',
    },
  },

  'auth.demo': {
    getStarted: {
      en: 'Get started with blym',
      fr: 'Commencer avec Blym',
    },
    bookADemo: {
      en: 'Book a Blym Enterprise Demo to get expert answers.',
      fr: 'Réserver une démo Blym pour obtenir des réponses expert.',
    },
    firstName: {
      en: 'First name',
      fr: 'Prénom',
    },
    lastName: {
      en: 'Last name',
      fr: 'Nom',
    },
    companyUrl: {
      en: 'Website Link',
      fr: 'Lien du site web',
    },
    workEmail: {
      en: 'Work email',
      fr: 'Email professionnel',
    },
    chooseDateAndTime: {
      en: 'Choose date and time',
      fr: "Choisir la date et l'heure",
    },
    backToWebsite: {
      en: 'Back to website',
      fr: 'Retour au site web',
    },
  },

  'auth.signup': {
    register: {
      en: 'Register',
      fr: "S'inscrire",
    },
    createAnAccount: {
      en: 'Create a Blym account',
      fr: 'Créer un compte Blym',
    },
    startFree: {
      en: 'Start free with Blym today',
      fr: 'Blym dès aujourd’hui',
    },
    signup: {
      en: 'Signup',
      fr: 'Inscription',
    },
    signUp: {
      en: 'Sign up',
      fr: 'Inscription',
    },
    confirmPassword: {
      en: 'Confirm password',
      fr: 'Confirmer le mot de passe',
    },
  },
  'auth.forgot': {
    recoverYourPassword: {
      en: 'Recover your password',
      fr: 'Récupérer votre mot de passe',
    },
    passwordRecovery: {
      en: 'Password recovery',
      fr: 'Récupération de mot de passe',
    },
    emailNotice: {
      en: 'If your email is in our database we will send a {{count}} digit security code to your email.',
      fr: 'Si votre e-mail est dans notre base de données, nous enverrons un code de sécurité à {{count}} chiffres à votre e-mail.',
    },
    enterNewPassword: {
      en: 'Enter new password',
      fr: 'Entrez un nouveau mot de passe',
    },
    changeYourPassword: {
      en: 'Change your password',
      fr: 'Modifier votre mot de passe',
    },
    newPassword: {
      en: 'New password',
      fr: 'Nouveau mot de passe',
    },
    repeatNewPassword: {
      en: 'Repeat new password',
      fr: 'Répétez le nouveau mot de passe',
    },
    savePasswordAndLogin: {
      en: 'Save password & Login',
      fr: 'Enregistrer le mot de passe et se connecter',
    },
    tooMuchCharacters: {
      en: 'Too much characters',
      fr: 'Trop de caractères',
    },
  },
};
